import React from "react";
import { Field } from "formik";
import { normalizeField } from "../inc/functions";
import {
	PhoneInputWrapper,
	SelectInput,
	FieldWrapper,
	MaskedInput,
	Rijksregisternummer,
} from "./fields";
import countries from "../inc/countries";
import errorMessages from "../inc/errorMessages";
import * as Yup from "yup";

export const PersonalFieldsSchema = Yup.object().shape({
	naam: Yup.string().required(errorMessages.required),
	voornaam: Yup.string().required(errorMessages.required),
	straat: Yup.string().required(errorMessages.required),
	huisnummer: Yup.string().required(errorMessages.required),
	gemeente: Yup.string().required(errorMessages.required),
	postcode: Yup.string().required(errorMessages.required),
	// land: Yup.string().required(errorMessages.required),
	telefoonnummer: Yup.string().required(errorMessages.required),
	emailadres: Yup.string().email(errorMessages.email).required(errorMessages.required),
	rijksregisternummer: Yup.string()
		.trim()
		.matches(/\d{2}.\d{2}.\d{2}.\d{3}.\d{2}/, "Ongeldig rijksregisternummer")
		.required(errorMessages.required),
	geboorteplaats: Yup.string().required(errorMessages.required),
	// geboorteland: Yup.string().required(errorMessages.required),
});

export const PersonalFields = ({ group = "", isBelgium=false, isRechtspersoon=false }) => {

	const fields = [
		{ name: "naam", label: isRechtspersoon ? "Naam van de vaste vertegenwoordiger" : "Naam", type: "text", required: true },
		{ name: "voornaam", label: isRechtspersoon ? "Voornaam van de vaste vertegenwoordiger" : "Voornaam", type: "text", required: true },
		{ name: "land", label: "Land", type: "country", required: true },
		{
			name: "straat",
			label: "Straat",
			type: "maskedInput",
			required: true,
			mask: isBelgium ? /^[a-zA-Z\s]*$/ : String,
		},
		{
			name: "huisnummer",
			label: "Huisnummer",
			type: "maskedInput",
			required: true,
			mask: isBelgium ? Number : String,
		},
		{ name: "bus", label: "Bus", type: "text", required: false },
		{
			name: "gemeente",
			label: "Gemeente",
			type: "maskedInput",
			required: true,
			mask: isBelgium ? /^[a-zA-Z\s]*$/ : String,
		},
		{
			name: "postcode",
			label: "Postcode",
			type: "maskedInput",
			required: true,
			mask: isBelgium ? Number : String,
		},
		{ name: "telefoonnummer", label: "Telefoonnummer", type: "phone", required: true },
		{ name: "emailadres", label: "Emailadres", type: "email", required: true },
		{
			name: "rijksregisternummer",
			label: "Rijksregisternummer",
			type: "rijksregisternummer",
			required: true,
		},
		{ name: "geboorteplaats", label: "Geboorteplaats", type: "text", required: true },
		{ name: "geboorteland", label: "Geboorteland", type: "country", required: true },
	].map(normalizeField);

	return (
		<>
			{fields.map((field, index) => {
				return (
					<React.Fragment key={`${group}personalFields.${index}`}>
						{field.type.match(/text|email|number/g) && (
							<FieldWrapper
								id={`${group}${field.id}`}
								name={`${group}${field.name}`}
								type={field.type}
								text={field.text}
								label={field.label}
								required={field.required}
							/>
						)}

						{field.type === "maskedInput" && (
							<MaskedInput
								mask={field.mask}
								id={`${group}${field.id}`}
								name={`${group}${field.name}`}
								text={field.text}
								label={field.label}
								required={field.required}
							/>
						)}

						{field.type === "country" && (
							<SelectInput
								id={`${group}${field.id}`}
								name={`${group}${field.name}`}
								placeholder="Selecteer land"
								options={countries}
								label={field.label}
								required={field.required}
							/>
						)}

						{field.type === "phone" && (
							<PhoneInputWrapper
								id={`${group}${field.id}`}
								name={`${group}${field.name}`}
								required={field.required}
								label={field.label}
							/>
						)}

						{field.type === "rijksregisternummer" && (
							<Rijksregisternummer
								id={`${group}${field.id}`}
								name={`${group}${field.name}`}
								required={field.required}
								label={field.label}
							/>
						)}
					</React.Fragment>
				);
			})}
		</>
	);
};
